import Header from './components/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import { WhatIsSection, WhySection, ComparisonSection } from './components/ContentSections';
import ResourceCards from './components/ResourceCards';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL;

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Basetao Sheet',
  url: SITE_URL,
  description: 'Independent Basetao Spreadsheet Research & Shopping Guide Platform',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Basetao Sheet',
  url: SITE_URL,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png',
  description: 'Independent Basetao Spreadsheet Research & Shopping Guide Platform — providing updated guides, honest reviews, shipping cost analysis, warehouse tips and expert buying tutorials.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: SITE_URL,
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <CategoryDropdown />
        <CategoryGrid />
        <WhatIsSection />
        <WhySection />
        <ComparisonSection />
        <ResourceCards />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}